import { render, staticRenderFns } from "./Slide3.vue?vue&type=template&id=609cca18&scoped=true&"
import script from "./Slide3.vue?vue&type=script&lang=ts&"
export * from "./Slide3.vue?vue&type=script&lang=ts&"
import style0 from "./Slide3.vue?vue&type=style&index=0&id=609cca18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609cca18",
  null
  
)

export default component.exports